import { Affiliate } from 'models/Integrations';
import useFetchAgencyIntegrationSettings from 'components/domain/integrationSettings/useFetchAgencyIntegrationSettings';
import useAppUser from '../../../../hooks/useAppUser';

const useHostfullyDevices = () => {
  const { isEmployeeManager } = useAppUser();
  const { integrationSettings } = useFetchAgencyIntegrationSettings();

  const isHostfullyDevicesEnabled =
    (isEmployeeManager &&
      integrationSettings?.find(
        ({ affiliateEnum }) => affiliateEnum === Affiliate.HOSTFULLYDEVICES,
      )?.isEnabled) ||
    false;

  return { isHostfullyDevicesEnabled };
};

export default useHostfullyDevices;
